<div class="p-6 flex-table-page">
  <!-- Header -->
  <div class="mb-6 flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800 mb-4">
      {{ "sku_barcode.title" | translate }}
    </h2>
  </div>

  <!-- Search Form -->
  <app-search-form
    [searchFormat]="searchFormConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      @if (canPrint()) {
        <app-button
          [label]="'common.actions.print' | translate"
          type="info"
          icon="print"
          (emitOnClick)="onPrint()"
        ></app-button>
      }
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      #advancedTable
      [dataSource]="rows()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [rows]="pageSize"
      [first]="page() * pageSize"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      [hasCheckColumn]="false"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
      class="w-full"
    >
      <ng-template
        #customTemplate
        let-value
        let-column="column"
        let-rowData="rowData"
        let-rowIndex="rowIndex"
      >
        @if (column?.prop === 'barcodePreview') {
          @if (getBarcodeHtml(rowData?.barcodeValue, rowIndex); as html) {
            <div class="barcode-preview" [innerHTML]="html"></div>
          } @else {
            <span class="text-xs text-gray-400">—</span>
          }
        }
      </ng-template>
    </advanced-data-table>
  </div>
</div>

<p-toast></p-toast>
